
export const SIGN_IN = 'SIGN_IN';
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR';
export const SIGN_IN_SUBMITTING = 'SIGN_IN_SUBMITTING';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_REMOVE_USER_INFO = 'SET_REMOVE_USER_INFO';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const FORGOT_PASSWORD_SUBMITTING = 'FORGOT_PASSWORD_SUBMITTING';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';

export const GET_GROUPS_AND_TRANSPORTERS = 'GET_GROUPS_AND_TRANSPORTERS';
export const GET_TRANSPORTERS_LIST = 'GET_TRANSPORTERS_LIST';
export const GET_GROUPS_AND_TRANSPORTERS_SUCCESS = 'GET_GROUPS_AND_TRANSPORTERS_SUCCESS';

export const TOAST_ERROR = 'TOAST_ERROR';
export const TOAST_SUCCESS = 'TOAST_SUCCESS';
export const HIDE_TOAST = 'HIDE_TOAST';
export const SET_SYSTEM_TIME = 'SET_SYSTEM_TIME';

export const GET_PACKING_TYPES = 'GET_PACKING_TYPES';
export const GET_PACKING_TYPES_SUCCESS = 'GET_PACKING_TYPES_SUCCESS';

export const GET_VEHICLE_TYPES = 'GET_VEHICLE_TYPES';
export const GET_VEHICLE_TYPES_SUCCESS = 'GET_VEHICLE_TYPES_SUCCESS';

export const GET_VEHICLE_BODY_TYPES = 'GET_VEHICLE_BODY_TYPES';
export const GET_VEHICLE_BODY_TYPES_SUCCESS = 'GET_VEHICLE_BODY_TYPES_SUCCESS';

export const GET_PAYMENT_CYCLES = 'GET_PAYMENT_CYCLES';
export const GET_PAYMENT_CYCLES_SUCCESS = 'GET_PAYMENT_CYCLES_SUCCESS';

export const GET_PRICING_BASIS = 'GET_PRICING_BASIS';
export const GET_PRICING_BASIS_SUCCESS = 'GET_PRICING_BASIS_SUCCESS';

export const GET_BUSINESS_VOLUMES = 'GET_BUSINESS_VOLUMES';
export const GET_BUSINESS_VOLUMES_SUCCESS = 'GET_BUSINESS_VOLUMES_SUCCESS';

export const GET_SLABS = 'GET_SLABS';
export const GET_SLABS_SUCCESS = 'GET_SLABS_SUCCESS';

export const GET_PRODUCT_CATEGORIES = 'GET_PRODUCT_CATEGORIES';
export const GET_PRODUCT_CATEGORIES_SUCCESS = 'GET_PRODUCT_CATEGORIES_SUCCESS';


export const CREATE_RFQ = 'CREATE_RFQ';
export const CREATE_FRESH_RFQ = 'CREATE';
export const CREATE_RFQ_SUBMITTING = 'CREATE_RFQ_SUBMITTING';
export const CREATE_RFQ_SUCCESS = 'CREATE_RFQ_SUCCESS';
export const DISCARD_RFQ = 'DISCARD_RFQ';
export const COPY_RFQ = 'COPY_RFQ';
export const COPY_RFQ_SUBMITTING = 'COPY_RFQ_SUBMITTING';

export const SET_RFQ_ACTIVE_VIEW = 'SET_RFQ_ACTIVE_VIEW';
export const SET_NEXT_RFQ_VIEW = 'SET_ACTIVE_RFQ_VIEW';
export const SET_PREVIOUS_RFQ_VIEW = 'SET_PREVIOUS_RFQ_VIEW';

export const GET_TRIPS = 'GET_TRIPS';
export const GET_TRIPS_SUCCESS = 'GET_TRIPS_SUCCESS';
export const GET_TRIPS_LOADING = 'GET_TRIPS_LOADING';
export const CLEAR_TRIPS = 'CLEAR_TRIPS';

export const ADD_TRIP = 'ADD_TRIP';
export const ADD_TRIP_SUCCESS = 'ADD_TRIP_SUCCESS';
export const ADD_TRIP_SUBMITTING = 'ADD_TRIP_SUBMITTING';
export const ADD_TRIP_ADDING = 'ADD_TRIP_ADDING';


export const DELETE_TRIP = 'DELETE_TRIP';
export const DELETE_TRIP_SUBMITTING = 'DELETE_TRIP_SUBMITTING';
export const DELETE_TRIP_SUCCESS = 'DELETE_TRIP_SUCCESS';


// RFQs
export const GET_RFQS = 'GET_RFQS';
export const GET_RFQS_CONTRACT = 'GET_RFQS_CONTRACT';
export const GET_RFQS_CONTRACT_DETAILS = 'GET_RFQS_CONTRACT_DETAILS';
export const DOWNLOAD_LOI_PDF = 'DOWNLOAD_LOI_PDF';
export const FETCH_CONTRACTED_RFQS_BETWEEN_DATES = 'FETCH_CONTRACTED_RFQS_BETWEEN_DATES';
export const GET_RFQS_ERROR = 'GET_RFQS_ERROR';
export const GET_RFQS_SUCCESS = 'GET_RFQS_SUCCESS';
export const GET_RFQ_TRIPS_SUCCESS = 'GET_RFQ_TRIPS_SUCCESS';
export const GETTING_RFQS = 'GETTING_RFQS';
export const CLEAR_RFQS = 'CLEAR_RFQS';

export const GET_RFQ_DETAIL = 'GET_RFQ_DETAIL';
export const GET_RFQ_DETAIL_SUCCESS = 'GET_RFQ_DETAIL_SUCCESS';
export const CLEAR_RFQ_DETAIL = 'CLEAR_RFQ_DETAIL';

export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
export const UPLOAD_DOCUMENT_SUBMITTING = 'UPLOAD_DOCUMENT_SUBMITTING';
export const UPLOAD_DOCUMENT_SUCCESS = 'UPLOAD_DOCUMENT_SUCCESS';
export const UPLOAD_DOCUMENT_FAIL = 'UPLOAD_DOCUMENT_FAIL';
export const SET_DOCUMENTS = 'SET_DOCUMENTS';

export const FETCH_BIDS = 'FETCH_BIDS';
export const FETCH_BIDS_SUBMITTING = 'FETCH_BIDS_SUBMITTING';
export const FETCH_BIDS_SUCCESS = 'FETCH_BIDS_SUCCESS';

export const FETCH_SEEKER_BIDS = 'FETCH_SEEKER_BIDS';
export const FETCH_SEEKER_BIDS_SUBMITTING = 'FETCH_SEEKER_BIDS_SUBMITTING';
export const FETCH_SEEKER_BIDS_SUCCESS = 'FETCH_SEEKER_BIDS_SUCCESS';
export const CLEAR_FETCH_SEEKER_BIDS = 'CLEAR_FETCH_SEEKER_BIDS';

export const POST_BID = 'POST_BID';
export const POST_BID_SUBMITTING = 'POST_BID_SUBMITTING';
export const POST_BID_SUCCESS = 'POST_BID_SUCCESS';

export const CHALLENGE_PRICE = 'CHALLENGE_PRICE';
export const CHALLENGE_PRICE_SUBMITTING = 'CHALLENGE_PRICE_SUBMITTING';
export const CHALLENGE_PRICE_SUCCESS = 'CHALLENGE_PRICE_SUCCESS';

export const SEND_LOI = 'SEND_LOI';
export const SEND_LOI_SUBMITTING = 'SEND_LOI_SUBMITTING';
export const SEND_LOI_SUCCESS = 'SEND_LOI_SUCCESS';

export const GET_SEEKER_TRANSPORTERS = 'GET_SEEKER_TRANSPORTERS';
export const GET_SEEKER_TRANSPORTERS_LOADING = 'GET_SEEKER_TRANSPORTERS_LOADING';
export const GET_SEEKER_TRANSPORTERS_SUCCESS = 'GET_SEEKER_TRANSPORTERS_SUCCESS';
export const CLEAR_SEEKER_TRANSPORTERS_LOADING = 'CLEAR_SEEKER_TRANSPORTERS_LOADING';


export const GET_SEEKER_TRANSPORTER_BIDS = 'GET_SEEKER_TRANSPORTER_BIDS';
export const CLEAR_SEEKER_TRANSPORTER_BIDS = 'CLEAR_SEEKER_TRANSPORTER_BIDS';
export const GET_SEEKER_TRANSPORTER_BIDS_LOADING = 'GET_SEEKER_TRANSPORTER_BIDS_LOADING';
export const GET_SEEKER_TRANSPORTER_BIDS_SUCCESS = 'GET_SEEKER_TRANSPORTER_BIDS_SUCCESS';

export const COUNTER_PRICE = 'COUNTER_PRICE';
export const COUNTER_PRICE_FOR_SEEKER = 'COUNTER_PRICE_FOR_SEEKER';
export const COUNTER_PRICE_SUBMITTING = 'COUNTER_PRICE_SUBMITTING';
export const COUNTER_PRICE_SUCCESS = 'COUNTER_PRICE_SUCCESS';

export const ACCEPT_REJECT_CP = 'ACCEPT_REJECT_CP';
export const ACCEPT_REJECT_LOI = 'ACCEPT_REJECT_LOI';
export const ACCEPT_REJECT_LOI_SUBMITTING = 'ACCEPT_REJECT_LOI_SUBMITTING';
export const ACCEPT_REJECT_LOI_SUCCESS = 'ACCEPT_REJECT_LOI_SUCCESS';

export const CHANGE_BID_END = 'CHANGE_BID_END';
export const CHANGE_TRIP_BID_END = 'CHANGE_TRIP_BID_END';
export const POST_BID_EXTENSION_APPROVAL = 'POST_BID_EXTENSION_APPROVAL';

export const GET_CHAT_MESSAGES = 'GET_CHAT_MESSAGES';
export const GET_CHAT_MESSAGES_SUBMITTING = 'GET_CHAT_MESSAGES_SUBMITTING';
export const GET_CHAT_MESSAGES_SUCCESS = 'GET_CHAT_MESSAGES_SUCCESS';

export const SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE';
export const SEND_CHAT_MESSAGE_SUBMITTING = 'SEND_CHAT_MESSAGE_SUBMITTING';
export const SEND_CHAT_MESSAGE_SUCCESS = 'SEND_CHAT_MESSAGE_SUCCESS';

export const CLEAR_CHAT_MESSAGE_COUNT = 'CLEAR_CHAT_MESSAGE_COUNT';
export const CLEAR_CHAT_MESSAGES = 'CLEAR_CHAT_MESSAGES';



export const DOWNLOAD_RFQ_TEMPLATE = 'DOWNLOAD_RFQ_TEMPLATE';
export const DOWNLOAD_RFQ_TEMPLATE_SUBMITTING = 'DOWNLOAD_RFQ_TEMPLATE_SUBMITTING';
export const DOWNLOAD_RFQ_TEMPLATE_SUCCESS = 'DOWNLOAD_RFQ_TEMPLATE_SUCCESS';

export const UPLOAD_RFQ = 'UPLOAD_RFQ';
export const UPLOAD_RFQ_SUBMITTING = 'UPLOAD_RFQ_SUBMITTING';
export const UPLOAD_RFQ_SUCCESS = 'UPLOAD_RFQ_SUCCESS';

export const DOWNLOAD_TRIPS_TEMPLATE = 'DOWNLOAD_TRIPS_TEMPLATE';
export const DOWNLOAD_TRIPS_TEMPLATE_SUBMITTING = 'DOWNLOAD_TRIPS_TEMPLATE_SUBMITTING';
export const DOWNLOAD_TRIPS_TEMPLATE_SUCCESS = 'DOWNLOAD_TRIPS_TEMPLATE_SUCCESS';

export const UPLOAD_TRIPS = 'UPLOAD_TRIPS';
export const UPLOAD_TRIPS_SUBMITTING = 'UPLOAD_TRIPS_SUBMITTING';
export const UPLOAD_TRIPS_SUCCESS = 'UPLOAD_TRIPS_SUCCESS';

export const DOWNLOAD_CHALLENGE_PRICE_TEMPLATE = 'DOWNLOAD_CHALLENGE_PRICE_TEMPLATE';
export const DOWNLOAD_CHALLENGE_PRICE_TEMPLATE_SUBMITTING = 'DOWNLOAD_CHALLENGE_PRICE_TEMPLATE_SUBMITTING';
export const DOWNLOAD_CHALLENGE_PRICE_TEMPLATE_SUCCESS = 'DOWNLOAD_CHALLENGE_PRICE_TEMPLATE_SUCCESS';

export const GET_TRANSPORTERS = 'GET_TRANSPORTERS';
export const GET_TRANSPORTERS_SUBMITTING = 'GET_TRANSPORTERS_SUBMITTING';
export const GET_TRANSPORTERS_SUCCESS = 'GET_TRANSPORTERS_SUCCESS';

export const GET_GROUPS = 'GET_GROUPS';
export const GET_GROUPS_SUBMITTING = 'GET_GROUPS_SUBMITTING';
export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';

export const CREATE_GROUP = 'CREATE_GROUP';
export const CREATE_GROUP_SUBMITTING = 'CREATE_GROUP_SUBMITTING';
export const CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS';

export const EDIT_GROUP = 'EDIT GROUP';

export const DELETE_GROUP = 'DELETE_GROUP';
export const DELETE_GROUP_SUBMITTING = 'DELETE_GROUP_SUBMITTING';
export const DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS';

export const DOWNLOAD_BIDDING_DETAILS = 'DOWNLOAD_BIDDING_DETAILS';
export const DOWNLOAD_BIDDING_DETAILS_SUBMITTING = 'DOWNLOAD_BIDDING_DETAILS_SUBMITTING';
export const DOWNLOAD_BIDDING_DETAILS_SUCCESS = 'DOWNLOAD_BIDDING_DETAILS_SUCCESS';

export const UPLOAD_BIDDING_DETAILS = 'UPLOAD_BIDDING_DETAILS';
export const UPLOAD_BIDDING_DETAILS_SUBMITTING = 'UPLOAD_BIDDING_DETAILS_SUBMITTING';
export const UPLOAD_BIDDING_DETAILS_SUCCESS = 'UPLOAD_BIDDING_DETAILS_SUCCESS';


export const GET_QBR = 'GET_QBR';
export const GET_QBR_SUBMITTING = 'GET_QBR_SUBMITTING';
export const GET_QBR_SUCCESS = 'GET_QBR_SUCCESS';

export const CP_FORM_MEGA_SAVE = 'CP_FORM_MEGA_SAVE';
export const POST_CHALLENGE_PRICE_FORM = 'POST_CHALLENGE_PRICE_FORM';
export const POST_CHALLENGE_PRICE_FORM_SUBMITTING = 'POST_CHALLENGE_PRICE_FORM_SUBMITTING';
export const POST_CHALLENGE_PRICE_FORM_SUCCESS = 'POST_CHALLENGE_PRICE_FORM_SUCCESS';

export const GET_REPORTS = 'GET_REPORTS';
export const GET_MARKET_ANALYSIS = 'GET_MARKET_ANALYSIS';
export const GET_ALLOCATIONS_REPORT = 'GET_ALLOCATIONS_REPORT';
export const GET_HOLISTICS = 'GET_HOLISTICS';
export const GET_HOLISTICS_SUBMITTING = 'GET_HOLISTICS_SUBMITTING';
export const GET_HOLISTICS_SUCCESS = 'GET_HOLISTICS_SUCCESS';
export const GET_MULTI_MODAL_REPORT = 'GET_MULTI_MODAL_REPORT';

export const UPDATE_LPP_DATA = 'UPDATE_LPP_DATA';
export const GET_LPP_DETAILS = 'GET_LPP_DETAILS';
export const LPP_DATA = 'LPP_DATA';

export const GET_BRANCHES = 'GET_BRANCHES';
export const GET_BRANCHES_DATA = 'GET_BRANCHES_DATA';

export const SEND_SFTP = 'SEND_SFTP';

export const GET_ALL_LOCATIONS = 'GET_ALL_LOCATIONS';
export const ALL_LOCATIONS_LIST = 'ALL_LOCATIONS_LIST';

export const UPLOAD_CP_FORM = 'UPLOAD_CP_FORM';
export const DOWNLOAD_CP_FORM = 'DOWNLOAD_CP_FORM';

export const GET_CP_LPP_DETAILS = 'GET_CP_LPP_DETAILS';

export const GET_AUTO_SUGGEST_LOCATIONS = 'GET_AUTO_SUGGEST_LOCATIONS';
export const AUTO_SUGGEST_LOCATIONS_DATA = 'AUTO_SUGGEST_LOCATIONS_DATA';

export const CANCEL_RFQ = 'CANCEL_RFQ';
export const CANCEL_RFQ_SUBMITTING = 'CANCEL_RFQ_SUBMITTING';
export const CANCEL_RFQ_SUCCESS = 'CANCEL_RFQ_SUCCESS';

export const GET_ALL_SUBPLANTS = 'GET_ALL_SUBPLANTS';
export const GET_ALL_SUBPLANTS_DATA = 'GET_ALL_SUBPLANTS_DATA';

export const FORGOT_PASSWORD_DETAILS = "FORGOT_PASSWORD_DETAILS";
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const RESET_PASSWORD_SUBMITTING = 'FRESET_PASSWORD_SUBMITTING';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';


export const CHANGE_PASSWORD_DETAILS = "CHANGE_PASSWORD_DETAILS";
export const CHANGE_PASSWORD_SUBMITTING = "CHANGE_PASSWORD_SUBMITTING";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";

export const GET_END_TO_END_MIS = 'GET_END_TO_END_MIS';

export const SAVE_EXTEND_DATE_DETAILS = 'SAVE_EXTEND_DATE_DETAILS';
export const SAVE_EXTEND_DATE_SUBMITTING = 'SAVE_EXTEND_DATE_SUBMITTING';
export const SAVE_EXTEND__DATE_SUCCESS = 'SAVE_EXTEND__DATE_SUCCESS';

export const INDENT_MIS = 'INDENT_MIS';

export const ADD_LOI_APPROVER = 'ADD_LOI_APPROVER';
export const ADD_LOI_SUBMITTING = 'ADD_LOI_SUBMITTING';
export const ADD_LOI_SUCCESS = 'ADD_LOI_SUCCESS';

//export const ADD_LOI_APPROVER = 'ADD_LOI_APPROVER';

export const SEND_APPROVER_LOI_MESSAGE = 'SEND_APPROVER_LOI_MESSAGE';

export const GET_NETWORK_DETAILS = 'GET_NETWORK_DETAILS';
export const SAVE_NETWORK_DETAILS = 'SAVE_NETWORK_DETAILS';

export const GET_TRANSPORTER_PARTICIPATION = 'GET_TRANSPORTER_PARTICIPATION';

export const GET_VOLTAS_MIS = 'GET_VOLTAS_MIS';
export const UPDATE_TK11 = 'UPDATE_TK11';

export const DELETE_TRIP_DETAILS = 'DELETE_TRIP_DETAILS';
export const DELETE_TRIP_DETAILS_SUCCESS = 'DELETE_TRIP_DETAILS_SUCCESS';

export const CHANGE_TRIP_BASE_VOLUME = 'CHANGE_TRIP_BASE_VOLUME';

export const GET_ROUTE_CODE = 'GET_ROUTE_CODE';
export const SAVE_ROUTE_CODE = 'SAVE_ROUTE_CODE';

export const EDIT_HEADING_CHARGES_URL = "EDIT_HEADING_CHARGES_URL";

export const GET_SERVER_TIME = "GET_SERVER_TIME";

export const DELETE_ADDED_TRIP = "DELETE_ADDED_TRIP";
export const DELETE_ADDED_TRIP_START = "DELETE_ADDED_TRIP_START";
export const DELETE_ADDED_TRIP_END = "DELETE_ADDED_TRIP_END";

export const GET_SECONDARY_TO_LOCATION = "GET_SECONDARY_TO_LOCATION";
export const GET_SECONDARY_TO_LOCATION_SUCCESS = "GET_SECONDARY_TO_LOCATION_SUCCESS";

export const OTHER_COST_CHALLENGE_PRICE = 'OTHER_COST_CHALLENGE_PRICE';
export const OTHER_COST_ACCEPT_REJECT_CP = 'OTHER_COST_ACCEPT_REJECT_CP';
export const GET_SECONDARY_UPTO_KM_LIST = 'GET_SECONDARY_UPTO_KM_LIST';
export const SAVE_SECONDARY_UPTO_KM_LIST = 'SAVE_SECONDARY_UPTO_KM_LIST';

export const SAVE_COURIER_TRIP_DETAILS = 'SAVE_COURIER_TRIP_DETAILS';

export const DOWNLOAD_BIDDING_TRAIL  = 'DOWNLOAD_BIDDING_TRAIL';
export const DOWNLOAD_BIDDING_TRAIL_SUBMITTING = 'DOWNLOAD_BIDDING_TRAIL_SUBMITTING';
export const DOWNLOAD_BIDDING_TRAIL_SUCCESS = 'DOWNLOAD_BIDDING_TRAIL_SUCCESS';

export const GET_TK11_EFFICIENCY_MIS = 'GET_TK11_EFFICIENCY_MIS';

export const GET_MOVEMENTS = 'GET_MOVEMENTS';
export const GET_MOVEMENTS_SUCCESS = 'GET_MOVEMENTS_SUCCESS';

export const GET_MODES = 'GET_MODES';
export const GET_MODES_SUCCESS = 'GET_MODES_SUCCESS';

export const GET_ZONES = 'GET_ZONES';
export const GET_ZONES_SUCCESS = 'GET_ZONES_SUCCESS';

export const GET_COURIER_SLABS = 'GET_COURIER_SLABS';
export const SAVE_COURIER_SLABS = 'SAVE_COURIER_SLABS';
export const GET_COURIER_TRIPS = 'GET_COURIER_TRIPS';
export const GET_COURIER_TRIPS_START = 'GET_COURIER_TRIPS_START';
export const GET_COURIER_TRIPS_SUCCESS = 'GET_COURIER_TRIPS_SUCCESS';
export const POST_COURIER_TRIPS = 'POST_COURIER_TRIPS';
export const POST_COURIER_TRIPS_END = 'POST_COURIER_TRIPS_END';

export const POST_COURIER_POST_BID = 'POST_COURIER_POST_BID';

export const PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE = 'PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE';
export const PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE_SUCCESS = 'PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE_SUCCESS';

export const PROVIDER_UPLOAD_SERVICE_CATEGORY_TEMPLATE = 'PROVIDER_UPLOAD_SERVICE_CATEGORY_TEMPLATE';
export const PROVIDER_UPLOAD_SERVICE_CATEGORY_TEMPLATE_SUCCESS = 'PROVIDER_UPLOAD_SERVICE_CATEGORY_TEMPLATE_SUCCESS';

export const GET_SERVICE_CATEGORY = 'GET_SERVICE_CATEGORY';
export const GET_SERVICE_CATEGORY_START = 'GET_SERVICE_CATEGORY_START';
export const GET_SERVICE_CATEGORY_END = 'GET_SERVICE_CATEGORY_END';
export const SAVE_SERVICE_CATEGORY = 'SAVE_SERVICE_CATEGORY';
export const UPDATE_SERVICE_CATEGORY = 'UPDATE_SERVICE_CATEGORY';

export const GET_TRANSPORTER_BID_COMMON_CHARGES = 'GET_TRANSPORTER_BID_COMMON_CHARGES';
export const GET_TRANSPORTER_BID_COMMON_CHARGES_CLEAR = 'GET_TRANSPORTER_BID_COMMON_CHARGES_CLEAR';
export const GET_TRANSPORTER_BID_COMMON_CHARGES_SUCCESS = 'GET_TRANSPORTER_BID_COMMON_CHARGES_SUCCESS';
export const SAVE_TRANSPORTER_BID_COMMON_CHARGES = 'SAVE_TRANSPORTER_BID_COMMON_CHARGES';
export const GET_IP_ADDRESS = 'GET_IP_ADDRESS';

export const CLEAR_MESSAGE  = 'CLEAR_MESSAGE';
export const CLEAR_MESSAGE_SUBMITTING = 'CLEAR_MESSAGE_SUBMITTING';
export const CLEAR_MESSAGE_SUCCESS = 'CLEAR_MESSAGE_SUCCESS';

export const GET_MANAGEMENT_SUMMARY_REPORT = 'GET_MANAGEMENT_SUMMARY_REPORT';
export const GET_PLANT_WISE_REPORT = 'GET_PLANT_WISE_REPORT';
export const GET_CURRENCY_DETAILS = 'GET_CURRENCY_DETAILS';
export const CURRENCY_DETAILS_SUCCESS = 'CURRENCY_DETAILS_SUCCESS';

export const GET_RFQ_TYPES = 'GET_RFQ_TYPES';
export const SAVE_RFQ_TYPES = 'SAVE_RFQ_TYPES';

export const GET_SYSTEM_SUGGESTED_PRICE = 'GET_SYSTEM_SUGGESTED_PRICE';
export const GET_REPORT_TEMPLATE = 'GET_REPORT_TEMPLATE';

export const POST_MARKET_RATE_REPORT = 'POST_MARKET_RATE_REPORT';


export const DOWNLOAD_AUDIT_TRAIL_FORM = 'DOWNLOAD_AUDIT_TRAIL_FORM';

export const GET_MARKET_REPORT_LOCATIONS = 'GET_MARKET_REPORT_LOCATIONS';
export const MARKET_REPORT_LOCATIONS_DATA = 'MARKET_REPORT_LOCATIONS_DATA';

export const CHECK_CONTRACT_EXIST = 'POST_CONTRACT_EXIST';

export const GET_YARD_TO_YRAD_CONSTANTS_LIST = 'GET_YARD_TO_YRAD_CONSTANTS_LIST';
export const SAVE_YARD_TO_YRAD_CONSTANTS_LIST = 'SAVE_YARD_TO_YRAD_CONSTANTS_LIST';

export const CALUCALATE_FREIGHT_RATE = 'CALUCALATE_FREIGHT_RATE';
export const GET_OTHER_LPP_DETAILS = 'GET_OTHER_LPP_DETAILS';
export const GET_AMMENDMENT_LIST_DATA = 'GET_AMMENDMENT_LIST_DATA';
export const GET_AMMENDMENT_STARTED = 'GET_AMMENDMENT_STARTED';
export const SAVE_AMMENDMENT_DATA_LIST = 'SAVE_AMMENDMENT_DATA_LIST';

export const PUT_AMMENDMENT_APPROVE_DATA = 'PUT_AMMENDMENT_APPROVE_DATA';
export const PUT_AMMENDMENT_APPROVE_STARTED = 'PUT_AMMENDMENT_APPROVE_STARTED';
export const SAVE_AMMENDMENT_APPROVE_LIST = 'SAVE_AMMENDMENT_APPROVE_LIST';

export const DOWNLOAD_MARKET_SITE_RATE_DETAILS = 'DOWNLOAD_MARKET_SITE_RATE_DETAILS';
export const DOWNLOAD_BIDDING_RATE = 'DOWNLOAD_BIDDING_RATE';
export const DOWNLOAD_BIDDING_RATE_SUBMITTING = 'DOWNLOAD_BIDDING_RATE_SUBMITTING';
export const DOWNLOAD_BIDDING_RATE_SUCCESS = 'DOWNLOAD_BIDDING_RATE_SUCCESS';

export const UPLOAD_BIDDING_RATE = 'UPLOAD_BIDDING_RATE';
export const UPLOAD_BIDDING_RATE_SUBMITTING = 'UPLOAD_BIDDING_RATE_SUBMITTING';
export const UPLOAD_BIDDING_RATE_SUCCESS = 'UPLOAD_BIDDING_RATE_SUCCESS';


export const DOWNLOAD_TRUCKS = 'DOWNLOAD_TRUCKS';
export const DOWNLOAD_TRUCKS_SUBMITTING = 'DOWNLOAD_TRUCKS_SUBMITTING';
export const DOWNLOAD_TRUCKS_SUCCESS = 'DOWNLOAD_TRUCKS_SUCCESS';

export const UPLOAD_NUMBER_OF_TRUCKS = 'UPLOAD_NUMBER_OF_TRUCKS';
export const UPLOAD_NUMBER_OF_TRUCKS_SUBMITTING = 'UPLOAD_NUMBER_OF_TRUCKS_SUBMITTING';
export const UPLOAD_NUMBER_OF_TRUCKS_SUCCESS = 'UPLOAD_NUMBER_OF_TRUCKS_SUCCESS';

export const NUMBER_OF_VEHICLE_PLACED = 'NUMBER_OF_VEHICLE_PLACED';
export const NUMBER_OF_VEHICLE_PLACED_SUBMITTING = 'NUMBER_OF_VEHICLE_PLACED_SUBMITTING';
export const NUMBER_OF_VEHICLE_PLACED_SUCCESS = 'NUMBER_OF_VEHICLE_PLACED_SUCCESS';

export const GET_EXISTING_CONTRACT_DETAILS = 'GET_EXISTING_CONTRACT_DETAILS';
export const GET_EXISTING_CONTRACT_DETAILS_SUBMITTING = 'GET_EXISTING_CONTRACT_DETAILS_SUBMITTING';
export const GET_EXISTING_CONTRACT_DETAILS_SUCCESS = 'GET_EXISTING_CONTRACT_DETAILS_SUCCESS';

export const POST_GENERATE_CONTRACT_DETAILS = 'POST_GENERATE_CONTRACT_DETAILS';
export const UPLOAD_MULTI_MODE_CONTRACTS = 'UPLOAD_MULTI_MODE_CONTRACTS';
export const DOWNLOAD_MULTI_MODE_CONTRACTS = 'DOWNLOAD_MULTI_MODE_CONTRACTS';

export const GET_GENERATED_CONTRACT_DETAILS = 'GET_GENERATED_CONTRACT_DETAILS';
export const GET_GENERATED_CONTRACT_DETAILS_SUCCESS = 'GET_GENERATED_CONTRACT_DETAILS_SUCCESS';

export const START_LOADER = 'START_LOADER';
export const END_LOADER = 'END_LOADER';

export const GET_MULTI_MODE_CONTAINER_LIST = 'GET_MULTI_MODE_CONTAINER_LIST';
export const SAVE_MULTI_MODE_CONTAINER_LIST = 'SAVE_MULTI_MODE_CONTAINER_LIST';
export const GET_MULTI_MODE_MOVEMENT_TYPE_LIST = 'GET_MULTI_MODE_MOVEMENT_TYPE_LIST';
export const SAVE_MULTI_MODE_MOVEMENT_TYPE_LIST = 'SAVE_MULTI_MODE_MOVEMENT_TYPE_LIST';
export const GET_PLANT_LOCATION_LIST = 'GET_PLANT_LOCATION_LIST';
export const SAVE_PLANT_LOCATION_LIST = 'SAVE_PLANT_LOCATION_LIST';
export const GET_DEPOT_LOCATION_LIST = 'GET_DEPOT_LOCATION_LIST';
export const SAVE_DEPOT_LOCATION_LIST = 'SAVE_DEPOT_LOCATION_LIST';
export const GET_CHA_LIST = 'GET_CHA_LIST';
export const SAVE_CHA_LIST = 'SAVE_CHA_LIST';

export const GET_FREIGHT_DETAILS_REPORT = 'GET_FREIGHT_DETAILS_REPORT';
export const GET_CURRENCY_TYPES = 'GET_CURRENCY_TYPES';
export const SAVE_CURRENCY_TYPES = 'SAVE_CURRENCY_TYPES';

export const VENDOR_WITH_DRAW_BID = 'VENDOR_WITH_DRAW_BID';

export const REVOKE_WITHDRAW_BID = 'REVOKE_WITHDRAW_BID';
export const REVOKE_WITHDRAW_BID_SUCCESS = 'REVOKE_WITHDRAW_BID_SUCCESS';
export const REVOKE_WITHDRAW_BID_SUBMITTING = 'REVOKE_WITHDRAW_BID_SUBMITTING';

export const CLOSED_RFQ = 'CLOSED_RFQ';

export const ACCEPTANCE_CEILING_PRICE = 'ACCEPTANCE_CEILING_PRICE';

export const LOI_CANCELLED ='LOI_CANCELLED';
export const LOI_CANCELLED_SUBMITTING ="LOI_CANCELLED_SUBMITTING";
export const LOI_CANCELLED_UPDATED_SUCCESS ="LOI_CANCELLED_UPDATED_SUCCESS";
export const STATUS_GROUP='STATUS_GROUP';

export const GET_UPLOAD_PLAN_DATA="GET_UPLOAD_PLAN_DATA";
export const GET_UPLOAD_PLAN="GET_UPLOAD_PLAN";
export const POST_UPLOAD_PLAN="POST_UPLOAD_PLAN";
export const UPDATE_UPLOAD_PLAN="UPDATE_UPLOAD_PLAN";
export const DELETE_UPLOAD_PLAN="DELETE_UPLOAD_PLAN";
export const GET_CONSIGNEE_DATA="GET_CONSIGNEE_DATA";
export const GET_CONSIGNEE="GET_CONSIGNEE";
export const UPLOAD_UP_FILE="UPLOAD_UP_FILE";
export const DOWNLOAD_UP_TEMPLATE="DOWNLOAD_UP_TEMPLATE";
export const DOWNLOAD_UPLOADPLAN_TEMPLATE="DOWNLOAD_UPLOADPLAN_TEMPLATE";

export const GET_CONTRACTING_SHORT_MIS = 'GET_CONTRACTING_SHORT_MIS';

export const DOWNLOAD_AWL_MULTIMODE_TEMPLATE = 'DOWNLOAD_AWL_MULTIMODE_TEMPLATE';
export const UPLOAD_AWL_MULTIMODE_TRIPS = 'UPLOAD_AWL_MULTIMODE_TRIPS';
export const GET_LOCATION_WITH_PINCODE = 'GET_LOCATION_WITH_PINCODE';

export const GET_GOOGLE_STUDIO_REPORT = 'GET_GOOGLE_STUDIO_REPORT';
export const SAVE_GOOGLE_STUDIO_REPORT = 'SAVE_GOOGLE_STUDIO_REPORT';
export const GET_HOLISTICS_TOKEN = 'GET_HOLISTICS_TOKEN';

export const GET_INCOTERMS_LIST = 'GET_INCOTERMS_LIST';
export const SAVE_INCOTERMS_LIST = 'SAVE_INCOTERMS_LIST';
export const GET_COST_HEADS_LIST = 'GET_COST_HEADS_LIST';
export const SAVE_COST_HEADS_LIST = 'SAVE_COST_HEADS_LIST';

export const GET_CARGO_SHIPMENT_TRACKING_DATA = 'GET_CARGO_SHIPMENT_TRACKING_DATA';
export const SAVE_CARGO_SHIPMENT_TRACKING_DATA = 'SAVE_CARGO_SHIPMENT_TRACKING_DATA';
export const START_CARGO_SHIPMENT_TRACKING_DATA = 'START_CARGO_SHIPMENT_TRACKING_DATA';

export const GET_DIESEL_PRICE = "GET_DIESEL_PRICE";

export const SAVE_SELECTED_BRANCH_DETAILS = 'SAVE_SELECTED_BRANCH_DETAILS';
export const POST_SELECTED_BRANCH_DETAILS = 'POST_SELECTED_BRANCH_DETAILS';

export const GET_FUEL_TYPES = 'GET_FUEL_TYPES';
export const GET_FUEL_TYPES_SUCCESS = 'GET_FUEL_TYPES_SUCCESS';

export const REQUEST_OTP_SUBMITTING = 'REQUEST_OTP_SUBMITTING';
export const REQUEST_OTP_SUCCESS = 'REQUEST_OTP_SUCCESS';
export const REQUEST_OTP = 'REQUEST_OTP';
export const LOGIN_WITH_OTP = 'LOGIN_WITH_OTP';
export const LOGIN_WITH_SSO = "LOGIN_WITH_SSO";
export const VALIDATE_SSO_USER = "VALIDATE_SSO_USER";
export const SSO_DELETE_TOKEN = "SSO_DELETE_TOKEN";
export const GET_CONTRACTING_INDENTING_MIS = 'GET_CONTRACTING_INDENTING_MIS';
export const GET_BROADCAST_MSG = 'GET_BROADCAST_MSG';
export const STORE_BROADCAST_MSG = 'STORE_BROADCAST_MSG';

export const GET_SSO_CONFIG = 'GET_SSO_CONFIG';
export const STORE_SSO_CONFIG_DATA = 'STORE_SSO_CONFIG_DATA';

export const GET_SPOT_CONTRACT_REASONS = 'GET_SPOT_CONTRACT_REASONS';
export const SAVE_SPOT_CONTRACT_REASONS = 'SAVE_SPOT_CONTRACT_REASONS';

export const GET_PROVIDER_TK11_MIS = 'GET_PROVIDER_TK11_MIS';
export const GET_SEA_AND_AIR_LINES_LIST = 'GET_SEA_AND_AIR_LINES_LIST';
export const SAVE_SEA_AND_AIR_LINES_LIST = 'SAVE_SEA_AND_AIR_LINES_LIST';

export const GET_ROUTE_MASTER_DETAILS = 'GET_ROUTE_MASTER_DETAILS';
export const SAVE_ROUTE_MASTER_DETAILS = 'SAVE_ROUTE_MASTER_DETAILS';
export const ADD_ROUTE_MASTER_DETAILS = 'ADD_ROUTE_MASTER_DETAILS';
export const UPDATE_ROUTE_MASTER_DETAILS = 'UPDATE_ROUTE_MASTER_DETAILS';
export const DELETE_ROUTE_MASTER_DETAILS = 'DELETE_ROUTE_MASTER_DETAILS';
export const UPLOAD_ROUTE_MASTER_DETAILS = 'UPLOAD_ROUTE_MASTER_DETAILS';
export const DOWNLOAD_ROUTE_MASTER_TEMPLATE = 'DOWNLOAD_ROUTE_MASTER_TEMPLATE';
export const DOWNLOAD_ROUTE_MASTER_DETAILS = 'DOWNLOAD_ROUTE_MASTER_DETAILS';

export const GET_CITY_MAPPING_DETAILS = 'GET_CITY_MAPPING_DETAILS';
export const ADD_CITY_MAPPING_DETAILS = 'ADD_CITY_MAPPING_DETAILS';
export const UPDATE_CITY_MAPPING_DETAILS = 'UPDATE_CITY_MAPPING_DETAILS';
export const DELETE_CITY_MAPPING_DETAILS = 'DELETE_CITY_MAPPING_DETAILS';

export const GET_TRANSPORTERS_LIST_SUCCESS = 'GET_TRANSPORTERS_LIST_SUCCESS';
export const CHECK_FTL_CONTRACT_EXIST = 'CHECK_FTL_CONTRACT_EXIST';
export const UPDATE_DPH_DETAILS = 'UPDATE_DPH_DETAILS';

export const GET_CONTRACT_TENURE_LIST = 'GET_CONTRACT_TENURE_LIST';
export const SAVE_CONTRACT_TENURE_LIST = 'SAVE_CONTRACT_TENURE_LIST';
export const TRIP_LEVEL_CONTRACT_EXTENSION = 'TRIP_LEVEL_CONTRACT_EXTENSION';
export const TRIP_LEVEL_BID_EXTENSION = 'TRIP_LEVEL_BID_EXTENSION';
export const POST_SHARE_OF_BUSINESS = 'POST_SHARE_OF_BUSINESS';
export const GET_SAP_ROUTE_CODES = 'GET_SAP_ROUTE_CODES';

export const POST_REJECT_LOI_FROM_APPROVER = 'POST_REJECT_LOI_FROM_APPROVER';
export const DOWNLOAD_EXISTING_CONTRACT_TEMPlATE = 'DOWNLOAD_EXISTING_CONTRACT_TEMPlATE';
export const UPLOAD_EXISTING_CONTRACT_DETAILS = 'UPLOAD_EXISTING_CONTRACT_DETAILS';

export const UPLOAD_FILE_IN_CONTRACT_RECORDS_RFQ = 'UPLOAD_FILE_IN_CONTRACT_RECORDS_RFQ';
export const POST_CREATE_INDENTS = 'POST_CREATE_INDENTS';
export const DELETE_UPLOADED_FILE = 'DELETE_UPLOADED_FILE';

export const POST_DPH_APPROVAL = 'POST_DPH_APPROVAL';
export const POST_APPROVE_DPH = 'POST_APPROVE_DPH';

export const RETRIGGER_TK11_FOR_RFQ = 'RETRIGGER_TK11_FOR_RFQ';

export const GET_EVENT_DETAILS = 'GET_EVENT_DETAILS';
export const SAVE_EVENT_DETAILS = 'SAVE_EVENT_DETAILS';
export const DELETE_EVENT_DETAILS = 'DELETE_EVENT_DETAILS';
export const DOWNLOAD_EVENT_DETAILS_TEMPLATE = 'DOWNLOAD_EVENT_DETAILS_TEMPLATE';
export const CREATE_NEW_EVENT = 'CREATE_NEW_EVENT';
export const GET_RFQ_EVENT = 'GET_RFQ_EVENT';
export const CANCEL_EVENT = 'CANCEL_EVENT';
export const POST_EVENT_DETAILS = 'POST_EVENT_DETAILS';
export const UPLOAD_RFQS_FOR_EVENT = 'UPLOAD_RFQS_FOR_EVENT';
export const SCHEDULE_EVENT = 'SCHEDULE_EVENT';
export const GET_EVENT_STATUS = 'GET_EVENT_STATUS';
export const SAVE_EVENT_STATUS = 'SAVE_EVENT_STATUS';
export const GET_EVENT_RFQ_TRIPS = 'GET_EVENT_RFQ_TRIPS';
export const UPDATE_EVENT_RFQ = 'UPDATE_EVENT_RFQ';
export const UPDATE_EVENT_RFQ_TRIPS = 'UPDATE_EVENT_RFQ_TRIPS';
export const DOWNLOAD_UPLOADED_FILE = 'DOWNLOAD_UPLOADED_FILE';
export const DOWNLOAD_UPLOADED_PRESIGNED_FILE = 'DOWNLOAD_UPLOADED_PRESIGNED_FILE';

export const UPLOAD_SOB_DETAILS = 'UPLOAD_SOB_DETAILS';
export const DOWNLOAD_SOB_TEMPLATE = 'DOWNLOAD_SOB_TEMPLATE';

export const GET_WINNING_TRANSPORTERS = 'GET_WINNING_TRANSPORTERS';
export const SAVE_WINNING_TRANSPORTERS = 'SAVE_WINNING_TRANSPORTERS';
export const DELETE_TRANSPORTER_IN_WINNIG_PAGE = 'DELETE_TRANSPORTER_IN_WINNIG_PAGE';
export const POST_WISHLIST_EVENT = 'POST_WISHLIST_EVENT';
export const GET_FTL_CONTRACT_TYPE = 'GET_FTL_CONTRACT_TYPE';
export const SAVE_FTL_CONTRACT_TYPE = 'SAVE_FTL_CONTRACT_TYPE';
export const DOWNLOAD_OFFLINE_SLABEWISE_TRIPS = 'DOWNLOAD_OFFLINE_SLABEWISE_TRIPS';
export const UPLOAD_OFFLINE_SLABEWISE_TRIPS = 'UPLOAD_OFFLINE_SLABEWISE_TRIPS';

export const GET_ALL_MASTER_CONTRACTS = 'GET_ALL_MASTER_CONTRACTS';
export const GET_ALL_MASTER_CONTRACTS_SUCCESS = 'GET_ALL_MASTER_CONTRACTS_SUCCESS';
export const GET_ALL_MASTER_CONTRACTS_LOADING = 'GET_ALL_MASTER_CONTRACTS_LOADING';
export const GET_FROM_ROUTE = 'GET_FROM_ROUTE';
export const GET_FROM_ROUTE_SUCCESS = 'GET_FROM_ROUTE_SUCCESS';
export const GET_FROM_ROUTE_LOADING = 'GET_FROM_ROUTE_LOADING';
export const GET_BRANCH_YARD_FILTERS = 'GET_BRANCH_YARD_FILTERS';
export const GET_BRANCH_YARD_FILTERS_SUCCESS = 'GET_BRANCH_YARD_FILTERS_SUCCESS';
export const GET_BRANCH_YARD_FILTERS_LOADING = 'GET_BRANCH_YARD_FILTERS_LOADING';
export const POST_SEARCH_ROUTES_CONTRACTS = 'POST_SEARCH_ROUTES_CONTRACTS';
export const POST_SEARCH_ROUTES_CONTRACTS_SUCCESS = 'POST_SEARCH_ROUTES_CONTRACTS_SUCCESS';
export const POST_SEARCH_ROUTES_CONTRACTS_LOADING = 'POST_SEARCH_ROUTES_CONTRACTS_LOADING';

export const GET_YARD_LOCATIONS = 'GET_YARD_LOCATIONS';
export const SAVE_YARD_LOCATIONS = 'SAVE_YARD_LOCATIONS';

export const GET_GENERATE_ROUTE_CODE = 'GET_GENERATE_ROUTE_CODE';
export const GENERATE_PLAN_IN_MASTER_CONTRACT = 'GENERATE_PLAN_IN_MASTER_CONTRACT';

export const ADD_ADDITIONAL_TRANSPORTER_DURING_BIDDING = 'ADD_ADDITIONAL_TRANSPORTER_DURING_BIDDING';
export const GET_RFQ_LEVEL_PR_DETAILS = 'GET_RFQ_LEVEL_PR_DETAILS';
export const GET_TRANSPORTER_LEVEL_PR_DETAILS = 'GET_TRANSPORTER_LEVEL_PR_DETAILS';
export const DOWNLOAD_PR_DETAILS = 'DOWNLOAD_PR_DETAILS';
export const GET_CLUSTER_DETAILS = 'GET_CLUSTER_DETAILS';
export const SAVE_CLUSTER_DETAILS = 'SAVE_CLUSTER_DETAILS';
export const GET_COMPANY_BRANCH_DETAILS = 'GET_COMPANY_BRANCH_DETAILS';
export const SAVE_COMPANY_BRANCH_DETAILS = 'SAVE_COMPANY_BRANCH_DETAILS';

export const GET_CONTRACT_DETAILS = 'GET_CONTRACT_DETAILS';

export const GET_CONTRACT_DETAILS_LOADING = 'GET_CONTRACT_DETAILS_LOADING';

export const GET_CONTRACT_DETAILS_SUCCESS = 'GET_CONTRACT_DETAILS_SUCCESS';

export const GET_CHILD_CONTRACT_TK11 = 'GET_CHILD_CONTRACT_TK11';

export const GET_MASTER_CONTRACT_TK11 = 'GET_MASTER_CONTRACT_TK11';

export const GET_CONTRACT_CHILD_DETAILS_LOADING = 'GET_CONTRACT_CHILD_DETAILS_LOADING';

export const GET_CONTRACT_CHILD_DETAILS_SUCCESS = 'GET_CONTRACT_CHILD_DETAILS_SUCCESS';

export const GET_ZONE_WISE_DETAILS = 'GET_ZONE_WISE_DETAILS';
export const SAVE_ZONE_WISE_DETAILS = 'SAVE_ZONE_WISE_DETAILS';

export const GET_VENDOR_BIDDING_STATUS = 'GET_VENDOR_BIDDING_STATUS';
export const SAVE_VENDOR_BIDDING_STATUS = 'SAVE_VENDOR_BIDDING_STATUS';
export const UPDATE_RFQ_LEVEL_VENDOR_BIDDING_STATUS = 'UPDATE_RFQ_LEVEL_VENDOR_BIDDING_STATUS';

export const GET_OTHER_CHARGES_TEMPLATE = 'GET_OTHER_CHARGES_TEMPLATE';
export const UPLOAD_OTHER_CHARGES = 'UPLOAD_OTHER_CHARGES';
export const RETRIGGER_MASTER_CONTRACTS_TK11 = 'RETRIGGER_MASTER_CONTRACTS_TK11';

export const GET_LOCATION_DROPDOWN_VALUES = 'GET_LOCATION_DROPDOWN_VALUES';

export const RETRIGGER_MASTER_CONTRACTS_TK11_LOADING = 'RETRIGGER_MASTER_CONTRACTS_TK11_LOADING';

export const RETRIGGER_MASTER_CONTRACTS_TK11_SUCCESS = 'RETRIGGER_MASTER_CONTRACTS_TK11_SUCCESS';

export const SAVE_RETRIGGER_MC_TK11 = 'SAVE_RETRIGGER_MC_TK11';


export const UPDATE_POST_BID_TO_PRE_BID_RFQ = 'UPDATE_POST_BID_TO_PRE_BID_RFQ';
export const DOWNLOAD_TRANSPORTER_WISE_BID_DETAILS = 'DOWNLOAD_TRANSPORTER_WISE_BID_DETAILS';
export const GET_MASTER_ROUTE_CODE_DETAILS = 'GET_MASTER_ROUTE_CODE_DETAILS';

export const GET_SECONDARY_CONTRACTS_LIST = 'GET_SECONDARY_CONTRACTS_LIST';
export const SAVE_SECONDARY_CONTRACTS_LIST = 'SAVE_SECONDARY_CONTRACTS_LIST';
export const GET_VENDOR_LIST = 'GET_VENDOR_LIST';
export const SAVE_VENDOR_LIST = 'SAVE_VENDOR_LIST';

export const DOWNLOAD_SECONDARY_CONTRACT_TEMPLATE = 'DOWNLOAD_SECONDARY_CONTRACT_TEMPLATE';
export const GET_CONTRACT_BY_RFQId = 'GET_CONTRACT_BY_RFQId';
export const DELETE_SECONDARY_CONTRACT_RFQ = 'DELETE_SECONDARY_CONTRACT_RFQ';
export const GET_SECONDARY_CONTRACT_CFA_DETAILS = 'GET_SECONDARY_CONTRACT_CFA_DETAILS';
export const SAVE_SECONDARY_CONTRACTS = 'SAVE_SECONDARY_CONTRACTS';
export const UPDATE_SECONDARY_CONTRACTS = 'UPDATE_SECONDARY_CONTRACTS';
export const UPLOAD_SECONDARY_CONTRACT_TRIPS = 'UPLOAD_SECONDARY_CONTRACT_TRIPS';
export const SAVE_SECONDARY_CONTRACT_CFA_DETAILS = 'SAVE_SECONDARY_CONTRACT_CFA_DETAILS';

export const DOWNLOAD_MULTI_CONTRACT_TEMP = 'DOWNLOAD_MULTI_CONTRACT_TEMP';
export const UPLOAD_MULTI_CONTRACT = 'UPLOAD_MULTI_CONTRACT';
export const GET_MULTI_CONTRACT_SUCCESS = 'GET_MULTI_CONTRACT_SUCCESS';
export const GET_MULTI_CONTRACT_LOADING = 'GET_MULTI_CONTRACT_LOADING';
export const GET_MULTI_CONTRACT_DETAILS = 'GET_MULTI_CONTRACT_DETAILS';
export const DELETE_MULTI_CONTRACT = 'DELETE_MULTI_CONTRACT';
export const GET_MULTI_CONTRACT_TYPES = 'GET_MULTI_CONTRACT_TYPES';
export const GET_TRIP_TYPES = 'GET_TRIP_TYPES';
export const SAVE_TRIP_TYPES = 'SAVE_TRIP_TYPES';
export const SAVE_MULTI_CONTRACT_TYPES = 'SAVE_MULTI_CONTRACT_TYPES';
export const UPDATE_MULTI_CONTRACT = 'UPDATE_MULTI_CONTRACT';
export const POST_MULTICONTRACT_APPROVE_LOADING = 'POST_MULTICONTRACT_APPROVE_LOADING';
export const POST_MULTICONTRACT_APPROVE_SUCCESS =  'POST_MULTICONTRACT_APPROVE_SUCCESS';
export const APPROVE_MULTI_CONTRACT = 'APPROVE_MULTI_CONTRACT';
export const REJECT_MULTI_CONTRACT = 'REJECT_MULTI_CONTRACT';
export const MULTI_CONTRACT_SEND_LOI_FOR_APPROVAL = 'MULTI_CONTRACT_SEND_LOI_FOR_APPROVAL';

export const GET_CONTAINER_TYPES = 'GET_CONTAINER_TYPES';
export const SAVE_CONTAINER_TYPES = 'SAVE_CONTAINER_TYPES';
export const GET_CONTAINER_TYPES_LIST = 'GET_CONTAINER_TYPES_LIST';
export const SAVE_CONTAINER_TYPES_LIST = 'SAVE_CONTAINER_TYPES_LIST';
export const GET_MULTI_MODE_ROUTE_CODE = 'GET_MULTI_MODE_ROUTE_CODE';
export const DOWNLOAD_CONTAINER_TEMPLATE = 'DOWNLOAD_CONTAINER_TEMPLATE';
export const UPLOAD_CONTAINER_TRIPS = 'UPLOAD_CONTAINER_TRIPS';
export const GET_CONTAINER_TRIPS = 'GET_CONTAINER_TRIPS';
export const POST_CONTAINER_TRIPS = 'POST_CONTAINER_TRIPS';
export const GET_CONTAINER_LPP = 'GET_CONTAINER_LPP';

export const DOWNLOAD_EXTISTING_TRIPS_REMARKS_TEMPLATE = 'DOWNLOAD_EXTISTING_TRIPS_REMARKS_TEMPLATE';
export const UPLOAD_EXTISTING_TRIPS_REMARKS = 'UPLOAD_EXTISTING_TRIPS_REMARKS_URL';

export const GET_OFFLINE_CONTRACTS_DETAILS_TO_UPDATE = 'GET_OFFLINE_CONTRACTS_DETAILS_TO_UPDATE';
export const POST_OFFLINE_CONTRACTS_UPDATED_DETAILS = 'POST_OFFLINE_CONTRACTS_UPDATED_DETAILS';
export const POST_ACCEPT_CEILING_PRICE_LOI = 'POST_ACCEPT_CEILING_PRICE_LOI';
export const POST_TRIP_FILE_REMARKS = 'POST_TRIP_FILE_REMARKS';
export const GET_REGION_NAMES = 'GET_REGION_NAMES';
export const SET_REGION_NAMES = 'SET_REGION_NAMES';
export const START_LOADER_T1 = 'START_LOADER_T1';
export const STOP_LOADER_T1 = 'STOP_LOADER_T1';

// Multimodal rate comparison action constants start here

export const GET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST =
    'GET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST';
export const SET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST =
    'SET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST';

export const GET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST =
    'GET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST';
export const SET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST =
    'SET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST';

export const GET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST =
    'GET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST';
export const SET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST =
    'SET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST';

    export const GET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST =
    'GET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST';
export const SET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST =
    'SET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST';

export const GET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST =
    'GET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST';
export const SET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST =
    'SET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST';

export const GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST =
'GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST';
export const SET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST =
'SET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST';

export const GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST =
'GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST';
export const SET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST =
'SET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST';

export const SET_MULTIMODE_RATE_COMPARISON_WAGON_TYPES_LIST = 
'SET_MULTIMODE_RATE_COMPARISON_WAGON_TYPES_LIST';

export const GET_RAIL_RAKE_LIST = 'GET_RAIL_RAKE_LIST';
export const SET_RAIL_RAKE_LIST = 'SET_RAIL_RAKE_LIST';

export const SET_DETAILED_CALCULATION_FOR_RAIL_FREIGHT = 'SET_DETAILED_CALCULATION_FOR_RAIL_FREIGHT';

export const GET_ORIGIN_DESTINATION_YARD_LIST = "GET_ORIGIN_DESTINATION_YARD_LIST";
export const SET_ORIGIN_DESTINATION_YARD_LIST = "SET_ORIGIN_DESTINATION_YARD_LIST";


// Multimodal rate comparison action constants end here

// New exim cargo tracking action constants start here

export const GET_EXIM_CARGO_TEMPLATE = 'GET_EXIM_CARGO_TEMPLATE';
export const SET_EXIM_CARGO_TEMPLATE = 'SET_EXIM_CARGO_TEMPLATE';

export const UPLOAD_EXIM_CARGO_TEMPLATE = 'UPLOAD_EXIM_CARGO_TEMPLATE';
export const SAVE_EXIM_CONTAINER_SKU_DETAILS = 'SAVE_EXIM_CONTAINER_SKU_DETAILS';

export const GET_EXIM_CONTAINER_BL_TRACKING_DETAILS = 'GET_EXIM_CONTAINER_BL_TRACKING_DETAILS';
export const SET_UPLOAD_SHIPMENT_DETAILS_LIST = 'SET_UPLOAD_SHIPMENT_DETAILS_LIST';

export const GET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS = 'GET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS';
export const SET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS = 'SET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS';

export const GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE = 'GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE';
export const SET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE = 'SET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE';

// New exim cargo tracking action constants end here



// Supplier RFQ  action constants start here

export const GET_CONSIGNOR_PICKUP_LOCATION_LIST = 'GET_CONSIGNOR_PICKUP_LOCATION_LIST';
export const SET_CONSIGNOR_PICKUP_LOCATION_LIST = 'SET_CONSIGNOR_PICKUP_LOCATION_LIST';

export const GET_SERVICE_TYPES_LIST = 'GET_SERVICE_TYPES_LIST';
export const SET_SERVICE_TYPES_LIST = 'SET_SERVICE_TYPES_LIST';

export const GET_SERVICE_MODE_TYPES_LIST = 'GET_SERVICE_MODE_TYPES_LIST';
export const SET_SERVICE_MODE_TYPES_LIST = 'SET_SERVICE_MODE_TYPES_LIST';

export const GET_CARGO_DETAILS_TYPES_LIST = 'GET_CARGO_DETAILS_TYPES_LIST';
export const SET_CARGO_DETAILS_TYPES_LIST = 'SET_CARGO_DETAILS_TYPES_LIST';

export const GET_CARGO_MATERIAL_PACKING_TEMAPLATE = 'GET_CARGO_MATERIAL_PACKING_TEMAPLATE';
export const SET_CARGO_MATERIAL_PACKING_TEMAPLATE = 'SET_CARGO_MATERIAL_PACKING_TEMAPLATE';

export const UPLOAD_CARGO_MATERIAL_PACKING_TEMAPLATE = 'UPLOAD_CARGO_MATERIAL_PACKING_TEMAPLATE';

export const GET_HANDLING_INSTRUCTION_TYPES_LIST = 'GET_HANDLING_INSTRUCTION_TYPES_LIST';
export const SET_HANDLING_INSTRUCTION_TYPES_LIST = 'SET_HANDLING_INSTRUCTION_TYPES_LIST';

export const GET_VEHICLE_TYPES_LIST = 'GET_VEHICLE_TYPES_LIST';
export const SET_VEHICLE_TYPES_LIST = 'SET_VEHICLE_TYPES_LIST';

export const CREATE_SUPPLIER_CONTRACT = 'CREATE_SUPPLIER_CONTRACT';

export const GET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS = 'GET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS';
export const SET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS = 'SET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS';
export const DOWNLOAD_SUPPLIER_TRANSPORTATION_CONTRACTS = 'DOWNLOAD_SUPPLIER_TRANSPORTATION_CONTRACTS';

export const GET_PACKING_TYPES_LIST = 'GET_PACKING_TYPES_LIST';
export const SET_PACKING_TYPES_LIST = 'SET_PACKING_TYPES_LIST';

export const GET_SUPPLIER_NAME_LIST = 'GET_SUPPLIER_NAME_LIST';
export const SET_SUPPLIER_NAME_LIST = 'SET_SUPPLIER_NAME_LIST';

export const CREATE_TRANSPORTATION_RFQ = 'CREATE_TRANSPORTATION_RFQ';

export const GET_SUPPLIER_DETAILS_RFQ = 'GET_SUPPLIER_DETAILS_RFQ';
export const SET_SUPPLIER_DETAILS_RFQ = 'SET_SUPPLIER_DETAILS_RFQ';

export const UPDATE_SUPPLIER_CONTRACT_DETAILS = 'UPDATE_SUPPLIER_CONTRACT_DETAILS';

export const DELETE_SUPPLIER_CONTRACT_RFQ_DETAILS = 'DELETE_SUPPLIER_CONTRACT_RFQ_DETAILS';

export const GET_TRANSPORTER_MAPPING_LIST = 'GET_TRANSPORTER_MAPPING_LIST';
export const SET_TRANSPORTER_MAPPING_LIST = 'SET_TRANSPORTER_MAPPING_LIST';

export const GET_PROVIDER_MATERIAL_PACKING_DETAILS = 'GET_PROVIDER_MATERIAL_PACKING_DETAILS';

// Supplier RFQ  action constants end here

export const POST_OVERALL_ALLOCATION = "POST_OVERALL_ALLOCATION";
export const STORE_SOURCE_ICD_BRANCH_LIST = "STORE_SOURCE_ICD_BRANCH_LIST";
export const GET_SOURCE_ICD_BRANCH_LIST = "GET_SOURCE_ICD_BRANCH_LIST";

export const STORE_ALL_ICD_BRANCH_LIST = "STORE_ALL_ICD_BRANCH_LIST";
export const GET_ALL_ICD_BRANCH_LIST = "GET_ALL_ICD_BRANCH_LIST";

export const STORE_ICD_DESTINATION_ROUTE_CODE = "STORE_ICD_DESTINATION_ROUTE_CODE";
export const GET_ICD_DESTINATION_ROUTE_CODE = "GET_ICD_DESTINATION_ROUTE_CODE";

export const DELETE_SECONDARY_CONTRACT_RFQ_TRIP = "DELETE_SECONDARY_CONTRACT_RFQ_TRIP";
export const DELETE_SECONDARY_CONTRACT_RFQ_TRIP_SUCCESS = "DELETE_SECONDARY_CONTRACT_RFQ_TRIP_SUCCESS";

export const UPLOAD_TARGET_PRICE = "UPLOAD_TARGET_PRICE";
export const DOWNLOAD_TARGET_PRICE_SUBMIT = "DOWNLOAD_TARGET_PRICE_SUBMIT";
export const DOWNLOAD_TARGET_PRICE_SUCCESS = "DOWNLOAD_TARGET_PRICE_SUCCESS";
export const DOWNLOAD_TARGET_PRICE = "DOWNLOAD_TARGET_PRICE";
export const GET_SEARCHED_SECONDARY_CONTRACT_RFQ_TRIPS = "GET_SEARCHED_SECONDARY_CONTRACT_RFQ_TRIPS";
export const SET_SEARCHED_SECONDARY_CONTRACT_RFQ_TRIPS = "SET_SEARCHED_SECONDARY_CONTRACT_RFQ_TRIPS";

// FOSROC - Extend the Bid Time for the Single Bided Trips action constants start here
export const EXTEND_BID_TIME_FOR_SINGLE_BIDDED_TRIPS = "EXTEND_BID_TIME_FOR_SINGLE_BIDDED_TRIPS";
// FOSROC - Extend the Bid Time for the Single Bided Trips action constants ends here

export const GET_CONSIGNEE_DETAILS_BY_NAME = 'GET_CONSIGNEE_DETAILS_BY_NAME';
export const STORE_CONSIGNOR_DETAILS_BY_NAME_DATA = 'STORE_CONSIGNOR_DETAILS_BY_NAME_DATA';

export const GET_SEEKER_COMPANY_LIST = 'GET_SEEKER_COMPANY_LIST';
export const SAVE_SEEKER_COMPANY_LIST = 'SAVE_SEEKER_COMPANY_LIST';
export const VALIDATE_FORGOT_PASSWORD = "VALIDATE_FORGOT_PASSWORD";

export const POST_ON_DEMAND_TRACKING = 'POST_ON_DEMAND_TRACKING';
export const SECONDARY_CONTRACT_TENURE_VALIDATION = 'SECONDARY_CONTRACT_TENURE_VALIDATION';
export const GET_PORT_DETAILS = 'GET_PORT_DETAILS';
export const SAVE_PORT_DETAILS = 'SAVE_PORT_DETAILS';

export const GET_EXIM_LPP_DETAILS = 'GET_EXIM_LPP_DETAILS';
export const REACTIVATE_TK11 = 'REACTIVATE_TK11';
export const CANCEL_CP = 'CANCEL_CP';
export const ACCEPT_TERMS_AND_CONDITIONS = 'ACCEPT_TERMS_AND_CONDITIONS';

export const GET_ALL_PO = 'GET_ALL_PO';
export const SAVE_ALL_PO = 'SAVE_ALL_PO';
export const CREATE_PO = 'CREATE_PO';
export const GET_PO_DROPDOWN_LISTS = 'GET_PO_DROPDOWN_LISTS';
export const SAVE_PO_DROPDOWN_LISTS = 'SAVE_PO_DROPDOWN_LISTS';
export const GET_PART_DETAILS = 'GET_PART_DETAILS';
export const SAVE_PART_DETAILS = 'SAVE_PART_DETAILS';
export const DOWNLOAD_PO_TEMPLATE = 'DOWNLOAD_PO_TEMPLATE';
export const UPLOAD_PO_DETAILS = 'UPLOAD_PO_DETAILS';
export const GET_RAW_MATERIALS_OR_PRODUCTION_STATUS = 'GET_RAW_MATERIALS_OR_PRODUCTION_STATUS';
export const SAVE_RAW_MATERIALS_OR_PRODUCTION_STATUS = 'RAW_MATERIALS_OR_PRODUCTION_STATUS';
export const UPDATE_RAW_MATERIALS_OR_PRODUCTION_STATUS = 'UPDATE_RAW_MATERIALS_OR_PRODUCTION_STATUS';
export const ACCEPT_REJECT_RAW_MATERIALS_OR_PRODUCTION_STATUS = 'ACCEPT_REJECT_RAW_MATERIALS_OR_PRODUCTION_STATUS';
export const CANCEL_PO = 'CANCEL_PO';
export const GET_PO_DATA_BY_ID = 'GET_PO_DATA_BY_ID';
export const UPDATE_PO = 'UPDATE_PO';
export const GET_PO_HISTORY = 'GET_PO_HISTORY';
export const GET_PO_STATUS_COUNT = 'GET_PO_STATUS_COUNT';
export const GET_PO_LIST = 'GET_PO_LIST';
export const DELETE_RAW_MATERIALS_OR_PRODUCTION_STATUS = 'DELETE_RAW_MATERIALS_OR_PRODUCTION_STATUS';
export const GET_SUPPLIER_ITEM_MASTER = 'GET_SUPPLIER_ITEM_MASTER';
export const SAVE_SUPPLIER_ITEM_MASTER = 'SAVE_SUPPLIER_ITEM_MASTER';

export const GET_TRIPS_LOG = 'GET_TRIPS_LOG';

export const GET_DEV_TOOLS_CONFIG = 'GET_DEV_TOOLS_CONFIG';

export const SAVE_USER_REPORT_UTILIZATION_EVENT = 'SAVE_USER_REPORT_UTILIZATION_EVENT';
export const GET_EXIM_AWL_PLANT_WISE_COST_HEADS = 'GET_EXIM_AWL_PLANT_WISE_COST_HEADS';

export const GET_PAYMENT_TERMS = 'GET_PAYMENT_TERMS';
export const SAVE_PAYMENT_TERMS = 'SAVE_PAYMENT_TERMS';
export const GET_SERVICE_MODE = 'GET_SERVICE_MODE';
export const SAVE_SERVICE_MODE = 'SAVE_SERVICE_MODE';
export const GET_VENDOR_WITH_MATERIAL_CODE = 'GET_VENDOR_WITH_MATERIAL_CODE';
export const SAVE_VENDOR_WITH_MATERIAL_CODE = 'SAVE_VENDOR_WITH_MATERIAL_CODE';
export const GET_PROCUREMENT_LPP_DETAILS = 'GET_PROCUREMENT_LPP_DETAILS';
export const GET_PR_TRACKING_DETAILS = 'GET_PR_TRACKING_DETAILS';
export const SAVE_PR_TRACKING_DETAILS = 'SAVE_PR_TRACKING_DETAILS';
export const DELETE_CONTRACT_RECORD = 'DELETE_CONTRACT_RECORD';
export const GENERATE_SERVICE_PO = 'GENERATE_SERVICE_PO';

export const DOWNLOAD_MULTIMODAL_OFFLINE_CONTRACT = 'DOWNLOAD_MULTIMODAL_OFFLINE_CONTRACT';
export const UPLOAD_MULTIMODAL_OFFLINE_CONTRACT = 'UPLOAD_MULTIMODAL_OFFLINE_CONTRACT';

export const SAVE_TRACK_SCREEN_TIMING = 'SAVE_TRACK_SCREEN_TIMING';

export const GET_TRANSPORTATION_MANAGEMENT_DATA = 'GET_TRANSPORTATION_MANAGEMENT_DATA';
export const POST_TRANSPORTATION_MANAGEMENT_DATA = 'POST_TRANSPORTATION_MANAGEMENT_DATA';
export const UPDATE_TRANSPORTATION_MANAGEMENT_DATA = 'UPDATE_TRANSPORTATION_MANAGEMENT_DATA';
export const DELETE_TRANSPORTATION_MANAGEMENT_DATA = 'DELETE_TRANSPORTATION_MANAGEMENT_DATA';
export const DOWNLOAD_TRANSPORTATION_MANAGEMENT_DATA = 'DOWNLOAD_TRANSPORTATION_MANAGEMENT_DATA';
export const UPLOAD_TRANSPORTATION_MANAGEMENT_DATA = 'UPLOAD_TRANSPORTATION_MANAGEMENT_DATA';
export const GET_VEHICLE_REGNUMBER_DETAILS = 'GET_VEHICLE_REGNUMBER_DETAILS';
export const GET_TTBIL_ROUTE_CODE_DETAILS = 'GET_TTBIL_ROUTE_CODE_DETAILS';
export const GET_AUDIT_LOG_DETAILS = 'GET_AUDIT_LOG_DETAILS';
export const GET_TERMS_AND_CONDITIONS = 'GET_TERMS_AND_CONDITIONS';
export const POST_TOLL_TAX_UPDATE_PRICE = 'POST_TOLL_TAX_UPDATE_PRICE';

export const GET_SIDEBAR_CONFIG = 'GET_SIDEBAR_CONFIG';
export const GET_DAAI_CONFIG ='GET_DAAI_CONFIG';
export const GET_COMPANY_DATA = 'GET_COMPANY_DATA';
export const GET_PROVIDER_DETAILS = 'GET_PROVIDER_DETAILS';

export const GET_DPH_DASHBOARD_LIST = 'GET_DPH_DASHBOARD_LIST';
export const GET_DPH_BRANCHES_LIST = 'GET_DPH_BRANCHES_LIST';
export const POST_DPH_SEND_TO_APPROVAL = 'POST_DPH_SEND_TO_APPROVAL';
export const GET_DPH_RFQ_DETAILS = 'GET_DPH_RFQ_DETAILS';
export const POST_DPH_APPROVE_REJECT_PROPOSAL = 'POST_DPH_APPROVE_REJECT_PROPOSAL';
export const POST_UPDATE_BUSINESS_VOLUME = 'POST_UPDATE_BUSINESS_VOLUME';
export const GET_DPH_APPROVER_DETAILS = 'GET_DPH_APPROVER_DETAILS';
export const GET_DPH_DOWNLOAD_EXCEL = 'GET_DPH_DOWNLOAD_EXCEL';

export const ADMIN_UPDATE_RFQ = 'ADMIN_UPDATE_RFQ';
export const ADMIN_UPDATE_RFQ_SUCCESS = 'ADMIN_UPDATE_RFQ_SUCCESS';

export const GET_USER_SESSION_DETAILS = 'GET_USER_SESSION_DETAILS';
export const GET_TEG_USER_DATA = 'GET_TEG_USER_DATA';
export const STORE_TEG_USER_DATA = 'STORE_TEG_USER_DATA';

export const UPDATE_DPH_CALCULATION_MASTER = 'UPDATE_DPH_CALCULATION_MASTER';
export const DOWNLOAD_DPH_CALCULATION_MASTER = 'DOWNLOAD_DPH_CALCULATION_MASTER';
export const UPLOAD_DPH_CALCULATION_MASTER = 'UPLOAD_DPH_CALCULATION_MASTER';

// Booking Reference action constants
export const GET_BOOKING_REFERENCE_LIST = 'GET_BOOKING_REFERENCE_LIST';
export const SET_BOOKING_REFERENCE_LIST = 'SET_BOOKING_REFERENCE_LIST';
export const SET_BOOKING_REFERENCE_FETCHING = 'SET_BOOKING_REFERENCE_FETCHING';

export const UPLOAD_BOOKING_REFERENCE = 'UPLOAD_BOOKING_REFERENCE';
export const SAVE_BOOKING_REFERENCE = 'SAVE_BOOKING_REFERENCE';
export const SET_BOOKING_REFERENCE_UPLOAD_SUBMITTING = 'SET_BOOKING_REFERENCE_UPLOAD_SUBMITTING';

export const UPDATE_BOOKING_COPY = 'UPDATE_BOOKING_COPY';
export const SET_BOOKING_COPY_UPDATE_SUBMITTING = 'SET_BOOKING_COPY_UPDATE_SUBMITTING';

export const DELETE_BOOKING_OCR_DATA = 'DELETE_BOOKING_OCR_DATA';
export const SET_BOOKING_OCR_DELETE_SUBMITTING = 'SET_BOOKING_OCR_DELETE_SUBMITTING';

export const MANAGE_BOOKING_BL = 'MANAGE_BOOKING_BL';
export const SET_BOOKING_BL_MANAGE_SUBMITTING = 'SET_BOOKING_BL_MANAGE_SUBMITTING';

export const DOWNLOAD_BOOKING_OCR_REPORT = 'DOWNLOAD_BOOKING_OCR_REPORT';
export const SET_BOOKING_OCR_REPORT_DOWNLOADING = 'SET_BOOKING_OCR_REPORT_DOWNLOADING';

export const DOWNLOAD_BL_FILE = 'DOWNLOAD_BL_FILE';
